import {ModalController} from '../../../../../modules/core/abstracts/controllers/modal-controller';

class CreateResidualVoucherModalController extends ModalController {
    constructor($uibModalInstance, $http, voucherToCreateResidualFor) {
        super($uibModalInstance);
        this.api = $http;
        this.voucherToCreateResidualFor = voucherToCreateResidualFor;
        this.model = {amount: 0};

        this.dataToSend = {
            state: false,
            newVoucherId: null
        };
    }

    save() {
        this.api.post(`vouchers/${this.voucherToCreateResidualFor.id}/create-residual`, this.model).then((response) => {
            this.dataToSend.state = true;
            this.newVoucherId = response.data.data.id;
            this.close();
        }, () => {
            this.dataToSend.state = false;
            this.close();
        });
    }
}

CreateResidualVoucherModalController.$inject = [
    '$uibModalInstance',
    '$http',
    'voucherToCreateResidualFor'
];


angular
    .module('festzelt-os.vouchers.main')
    .controller('CreateResidualVoucherModalController', CreateResidualVoucherModalController);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/controllers/modals/create-residual-modal-controller.js